<div class="bar clearfix">
    <div class="label">{{skill.label}}</div>
    <div class="progress-container">
        <div class="progress" [style.width.%]="progress">
            <div class="percentage">{{progress}}%</div>
        </div>
    </div>
</div>